import { useEffect } from "react";

function useOnBeforeUnload(callback, slug, enable) {
  useEffect(() => {
    function onUnload(event) {
      if (enable) {
        callback();
        event.returnValue = "There is pending work. Sure you want to leave?";
        return event.returnValue;
      }

      return null;
    }

    window.addEventListener("beforeunload", onUnload);

    return function cleanUp() {
      return window.removeEventListener("beforeunload", onUnload);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [slug, enable]);
}

export default useOnBeforeUnload;
